import { FormControlLabel, Radio } from '@mui/material';
import { StyledRadioRow, StyledRadioText } from '../BaseExcelExportDialog.styles';
import { RadioOptionProps } from './RadioOption.props';

export const RadioOption = ({ value, label }: RadioOptionProps) => (
  <StyledRadioRow>
    <FormControlLabel value={value} control={<Radio />} label={<StyledRadioText>{label}</StyledRadioText>} />
  </StyledRadioRow>
);
